/* eslint-disable no-console */

import Vapi from 'vuex-rest-api'
import axios from 'axios'
const api = new Vapi({
  axios,
  state: {
    notifications: [],
  },
})
  .get({
    action: 'getNotifications',
    property: 'notifications',
    path: '/notifications',
    queryParams: true,
  })
  .delete({
    action: '_deleteNotification',
    property: 'deleteNotificationResult',
    path: ({ id }) => `/notification/${id}`
  })
  .put({
    action: 'notificationsRead',
    property: 'notificationsReadResult',
    path: '/notifications/read'
  })
  .delete({
    action: 'notificationsRemove',
    property: 'notificationsRemoveResult',
    path: '/notifications/remove'
  })
  .getStore({ namespaced: true })


const actions = {
  deleteNotification({ state, dispatch, commit }, id) {
    dispatch('_deleteNotification', {params: { id } });
    commit('deleteNotificationById', id);
  },
  ...api.actions
}
const getters = {
  notifications: (state) => state.notifications,
  ...api.getters
}

const mutations = {
  addNotification(state, payload) {
    state.notifications = [...state.notifications, ...[payload]]
  },
  updateNotification(state, payload) {
    state.notifications = [...state.notifications.map((x) => (x.id !== payload.id ? x : payload))]
  },
  deleteNotificationById(state, id) {
    state.notifications = state.notifications.filter((x) => x.id !== id)
  },
  ...api.mutations
}

export default {
  ...api,
  namespaced: true,
  getters,
  mutations,
  actions,
}
